module.exports = __webpack_public_path__ + "static/media/ana_rita_santos.417c55bd.jpg";